var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "smartphone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.309,
    height: 18.379,
    viewBox: "0 0 14.309 18.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241",
    transform: "translate(0 2.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    "data-name": "Group 1240",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4684",
    "data-name": "Path 4684",
    d: "M91,91v12.369h14.309V91Zm2.6,2.061a.669.669,0,0,1,.65-.687h2.6a.669.669,0,0,1,.65.687V95.81a.669.669,0,0,1-.65.687h-2.6a.669.669,0,0,1-.65-.687Zm8.455,8.933h-7.8a.688.688,0,0,1,0-1.374h7.8a.688.688,0,0,1,0,1.374Zm0-2.749h-7.8a.688.688,0,0,1,0-1.374h7.8a.688.688,0,0,1,0,1.374Zm0-2.749h-2.6a.688.688,0,0,1,0-1.374h2.6a.688.688,0,0,1,0,1.374Zm0-2.749h-2.6a.688.688,0,0,1,0-1.374h2.6a.688.688,0,0,1,0,1.374Z",
    transform: "translate(-91 -91)",
    fill: "#dadde5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1242",
    "data-name": "Group 1242",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4685",
    "data-name": "Path 4685",
    d: "M103.358,0H92.951A2.011,2.011,0,0,0,91,2.061v.687h14.309V2.061A2.011,2.011,0,0,0,103.358,0Z",
    transform: "translate(-91)",
    fill: "#dadde5"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1245",
    "data-name": "Group 1245",
    transform: "translate(3.898 5.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 1.462,
    height: 1.462,
    fill: "#dadde5"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1247",
    "data-name": "Group 1247",
    transform: "translate(0 12.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1246",
    "data-name": "Group 1246",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4686",
    "data-name": "Path 4686",
    d: "M91,392v3.436a2.011,2.011,0,0,0,1.951,2.061h10.406a2.011,2.011,0,0,0,1.951-2.061V392Zm8.455,2.749h-2.6a.688.688,0,0,1,0-1.374h2.6a.688.688,0,0,1,0,1.374Z",
    transform: "translate(-91 -392)",
    fill: "#dadde5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.02cee87a1ad2d3ebfff461e0e1c85e01.svg";
export { ForwardRef as ReactComponent };